import { AppState } from './types'

export default {
	loading: false,
	error: null,
	session: undefined,
	theme: 'light',
	navigation: [],
	headerHeight: 110,
	topbarOpen: true,
	leftDrawerOpen: false,
	leftDrawerWidth: 240,
	leftDrawerOptions: {},
	rightDrawerOpen: false,
	rightDrawerWidth: 200,
	rightDrawerOptions: {},
	footerOpen: true,
	navigationVisible: true,
	footerQuicklinksVisible: true,
	footerContactVisible: true,
	footerNewsletterVisible: true,
	footerSocialVisible: true,
	footerLegalVisible: true,
	footerCopyrightVisible: true
} as AppState
